import React from "react";
import { connect } from "react-redux";
import { USER_VIEW } from "../../common/constant/common-constants";
import NX5_MonitorVitalDataDesktopView from "./NX5_MonitorVitalDataDesktopView";
import NX5_MonitorVitalDataMobileView from "./NX5_MonitorVitalDataMobileView";


function NX5_MonitorVitalData(props) {
    return (
        <>
            {props.config?.userView === USER_VIEW.DESKTOP && (
                <NX5_MonitorVitalDataDesktopView props={props} />
            )}

            {props.config?.userView === USER_VIEW.MOBILE && (
                <NX5_MonitorVitalDataMobileView props={props} />
            )}
        </>
    );
}

const mapStateToProps = (state, ownProps) => {
    let alarmData = state?.alarmDataReducer?.alarmData?.[ownProps.bedId];

    return {
        alarmData: alarmData,
        config: state.configReducer.config,
    };
};

export default connect(mapStateToProps, null)(NX5_MonitorVitalData);
